const EditIcon = ({ style = { width: "1.75vh", height: "1.75vh" }, color }) => {
  return (
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="m.6 43.8c-.3 1 0 2.1.8 2.9.6.6 1.3.9 2.1.9.3 0 .5 0 .8-.1l14.4-3.9 27.6-27.6c1.8-1.8 1.8-4.6 0-6.4l-7.7-7.7c-.9-.9-2-1.3-3.2-1.3s-2.3.5-3.2 1.3l-27.7 27.5zm6-10.5c.7.5 1.6.8 2.4.9.1 1.2.7 2.3 1.6 3.2s2 1.4 3.2 1.6c.1.9.4 1.7.9 2.4l-6 1.7-3.8-3.8zm8.1 2.7c-.7.1-1.5-.2-2-.7s-.8-1.2-.7-2l20.7-20.7 2.7 2.7zm-4.8-4.8c-.7.1-1.5-.2-2-.7 0 0-.1-.1-.1-.1l21.3-21.4 1.5 1.5zm-6.4 13.4.5-2 1.4 1.4zm14.1-4.4s-.1-.1-.1-.1c-.5-.5-.8-1.2-.7-2l20.7-20.7 1.5 1.5zm16.6-36.3c.6-.6 1.6-.6 2.2 0l7.7 7.7c.6.6.6 1.6 0 2.2l-3 3-9.9-9.9z"
        fill={color}
      />
    </svg>
  );
};

export default EditIcon;
